import { Events } from '@/utils/servicesEvents'
import { Network } from '@/utils/network'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getStoresStats(stores, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(stores)
  const parsedResponse = parseResponse(response, stores)
  const event = parsedResponse.statusCode == 200 ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(event, parsedResponse)
}

async function sendRequest(stores) {
  const url = urls.proxyRequestSimultaneous
  const data = {
    requests: [],
  }
  stores.forEach(store => {
    Object.keys(urls.storesStats).forEach(statKey => {
      data.requests.push({
        method: 'get',
        id: `${statKey}_${store.id}`,
        url: urls.storesStats[statKey].replace(/{data::storeId}/, store.id),
      })
    })
  })

  const response = await Network.sendPostRequest(url, data)

  return response
}

function parseResponse(response, stores) {
  if (response && response.status.code === 200) {
    const rawData = response.response
    const appData = Formatter.parseStoresStats(rawData, stores)

    return {
      statusCode: 200,
      data: appData,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getStoresStats }
